module.exports = __webpack_public_path__ + "img/info_icon.b908acb0.svg";